export const IMAGE_FORMAT = {
    CROPPED: 'cropped',
    ZOOMED: 'zoomed'
};
